import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../common/url-query/url-query.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RoutingServersSettingsApiService {

  constructor(private http: HttpClient) {}

  private readonly routingServersUrl: string = 'server';
  private readonly topologyRouterUrl: string = 'topology/router';

  public getRoutingServers(parameters: any = {}): Observable<any> {
    const generatedUrl = UrlQueryService.addQueryParameters(this.routingServersUrl, parameters);

    return this.http.get(generatedUrl);
  }

  public addNewRoutingServer(routingServer): Observable<any> {
    return this.http.post(this.routingServersUrl, routingServer);
  }

  public updateRoutingServer(routingServer): Observable<any> {
    return this.http.put(`${this.routingServersUrl}/${routingServer.id}`, routingServer);
  }

  public deleteRoutingServer(routingServer): Observable<any> {
    return this.http.delete(`${this.routingServersUrl}/${routingServer.id}`);
  }

  public lockRoutingServer(routingServer): any {
    const lock = {lock : this.adminStateToInt(routingServer.adminState)};

    return this.http.put(`${this.topologyRouterUrl}/${routingServer.id}/lock`, lock);
  }

  public getCurrentServerCertificate(routingServerId): Observable<any> {
    const url = `server/${routingServerId}/keystore`;

    return this.http.get(url);
  }

  public generateServerKeystore(certificate, routingServerId): Observable<any> {
    const url = `server/${routingServerId}/keystore/generate`;

    return this.http.post(url, certificate);
  }

  public uploadServerKeystore(certificate, routingServerId): Observable<any> {
    const url = `server/${routingServerId}/keystore/upload`;

    return this.uploadKeystore(url, certificate);
  }

  public uploadServerKeystoreAndCsr(certificate, routingServerId): Observable<any> {
    const url = `server/${routingServerId}/keystore/csr/upload`;

    return this.uploadKeystoreAndCsr(url, certificate);
  }

  private adminStateToInt(adminState): any {
    return (adminState === 'UNLOCKED') ? 0 : 1;
  }

  private uploadKeystore(url, certificate): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('keystore', certificate.keyStoreFile);

    if (!_.isNil(certificate.password)) {
      formData.append('storepass', certificate.password);
    }

    return this.http.post(url, formData);
  }

  private uploadKeystoreAndCsr(url, certificate): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('keystore', certificate.keyStoreFile);
    formData.append('response', certificate.csrfile);

    if (!_.isNil(certificate.password)) {
      formData.append('storepass', certificate.password);
    }

    if (!_.isNil(certificate.alias)) {
      formData.append('alias', certificate.alias);
    }

    return this.http.post(url, formData);
  }
}
